// <tr>
// <th>{{ "QUERY.I_NUM_PETICION" | translate }}</th>
// <th>{{ "QUERY.PA_NOM_PACIENTE" | translate }}</th>
// <th>Centro</th>
// <th>Fecha Peticion</th>
// <th>Fecha Emision</th>
// <th>Fecha Cita</th>
// <th>Fecha Extraccion</th>
// <th>Fecha Registro</th>
// <th>Fecha Recepcion</th>
// <th>Motivo Solicitud</th>
// <th>Urgente</th>
// <th>Comentario</th>
// <th>Info 2</th>
// <th>Info 3</th>
// <th>Info 4</th>
// <th>Fecha Validación episodio</th>
// <th>Episodio</th>
// <th>Prioridad</th>
// <th>Destino</th>
// <th>Sistema Externo</th>
// <th>Número Externo (Pedido HCIS)</th>
// <th>Fecha Externo</th>
// <th>Observaciones HCIS</th>
// <th>Extractor</th>
// <th>Número de citas</th>
// <th>Fecha de cita</th>
// <th>Unidad peticionaria de HCIS</th>
// <th>Mikroattrib 2</th>
// <th>Mikroattrib 3</th>
// <th>Mikroattrib 4</th>
// <th>Mikroattrib 5</th>
// <th>Adicional 1 Informes</th>
// <th>Adicional 2 Informes</th>
// <th>Fecha Metodo Dt</th>
// <th>Fecha Resultado</th>
// <th>Fecha Validacion Dt</th>
// <th>Fecha Impresion</th>
// <th>Resultado</th>
// <th>Tipo Registro</th>
// <th>Facturable</th>
// <th>Determinaciones Urgente</th>
// <th>Rescuanti</th>
// <th>Patologia</th>
// <th>Determinaciones Adicional 1</th>
// <th>Visibilidad</th>
// <th>Analizador</th>
// <th>Metodo</th>
// <th>Area</th>
// <th>Resultado 2</th>
// <th>Rescuanti 2</th>
// <th>Nom Paciente</th>
// <th>Apellidos</th>
// <th>Fecha Nac</th>
// <th>Sexo</th>
// <th>Paciente Cod 1</th>
// <th>Paciente Cod 2</th>
// <th>Paciente Cod 3</th>
// <th>Domicilio</th>
// <th>Codigo Postal</th>
// <th>Ciudad</th>
// <th>Pais</th>
// <th>Pais Origen</th>
// <th>Raza</th>
// <th>Servicio</th>
// <th>Nombre Servicio</th>
// <th>Cod Diagnostico</th>
// <th>Desc Diagnostico</th>
// <th>Desc L Diagnostico</th>
// <th>Desc Areavalidacion</th>
// <th>Cod Destino</th>
// <th>Desc Destino</th>
// <th>Cod Centro</th>
// <th>Nombre Centro</th>
// <th *ngFor="let item of camposSensibilidad">
//   {{ camelCaseToTitleCase(item) }}
// </th>
// </tr>
// </ng-template>
// <ng-template pTemplate="body" let-record>
// <tr>
// <td>{{ record.numPeticion }}</td>
// <td>{{ record.nomPaciente }} {{ record.apellidos }}</td>
// <td>{{ record.descLCentro }}</td>
// <td>{{ record.fechaPeticionDt | date : "dd-MM-yy HH:mm" }}</td>
// <td>{{ record.fechaEmisionDt | date : "dd-MM-yy HH:mm" }}</td>
// <td>{{ record.fechaCita | date : "dd-MM-yy HH:mm" }}</td>
// <td>{{ record.fechaExtraccion | date : "dd-MM-yy HH:mm" }}</td>
// <td>{{ record.fechaRegistro | date : "dd-MM-yy HH:mm" }}</td>
// <td>{{ record.fechaRecepcion | date : "dd-MM-yy HH:mm" }}</td>
// <td>{{ record.motivoSolicitud }}</td>
// <td>{{ record.urgente }}</td>
// <td>{{ record.info_1 }}</td>
// <td>{{ record.info_2 }}</td>
// <td>{{ record.info_3 }}</td>
// <td>{{ record.info_4 }}</td>
// <td>{{ record.info4Dt | date : "dd-MM-yy HH:mm" }}</td>
// <td>{{ record.info_5 }}</td>
// <td>{{ record.info_6 }}</td>
// <td>{{ record.info_7 }}</td>
// <td>{{ record.info_8 }}</td>
// <td>{{ record.info_9 }}</td>
// <td>{{ record.info_10 }}</td>
// <td>{{ record.attrib1 }}</td>
// <td>{{ record.attrib2 }}</td>
// <td>{{ record.attrib3 }}</td>
// <td>{{ record.attrib4 }}</td>
// <td>{{ record.attrib5 }}</td>
// <td>{{ record.mikroattrib2 }}</td>
// <td>{{ record.mikroattrib3 }}</td>
// <td>{{ record.mikroattrib4 }}</td>
// <td>{{ record.mikroattrib5 }}</td>
// <td>{{ record.adicional1informes }}</td>
// <td>{{ record.adicional2informes }}</td>
// <td>{{ record.fechaMetodoDt | date : "dd-MM-yy HH:mm" }}</td>
// <td>{{ record.fechaResultado | date : "dd-MM-yy HH:mm" }}</td>
// <td>{{ record.fechaValidacionDt | date : "dd-MM-yy HH:mm" }}</td>
// <td>{{ record.fechaImpresion | date : "dd-MM-yy HH:mm" }}</td>
// <td>{{ record.resultado }}</td>
// <td>{{ record.tipoRegistro }}</td>
// <td>{{ record.facturable }}</td>
// <td>{{ record.determinacionesUrgente }}</td>
// <td>{{ record.rescuanti }}</td>
// <td>{{ record.patologia }}</td>
// <td>{{ record.determinacionesAdicional1 }}</td>
// <td>{{ record.visibilidad }}</td>
// <td>{{ record.descLAnalizador }}</td>
// <td>{{ record.descLMetodo }}</td>
// <td>{{ record.descLAreas }}</td>
// <td>{{ record.resultado2 }}</td>
// <td>{{ record.rescuanti2 }}</td>
// <td>{{ record.nomPaciente }}</td>
// <td>{{ record.apellidos }}</td>
// <td>{{ record.fechaNac | date : "dd-MM-yy" }}</td>
// <td>{{ record.sexo }}</td>
// <td>{{ record.pacienteCod_1 }}</td>
// <td>{{ record.pacienteCod_2 }}</td>
// <td>{{ record.pacienteCod_3 }}</td>
// <td>{{ record.domicilio }}</td>
// <td>{{ record.codigoPostal }}</td>
// <td>{{ record.ciudad }}</td>
// <td>{{ record.pais }}</td>
// <td>{{ record.paisOrigen }}</td>
// <td>{{ record.raza }}</td>
// <td>{{ record.codServicio }}</td>
// <td>{{ record.nombreServicio }}</td>
// <td>{{ record.codDiagnostico }}</td>
// <td>{{ record.descDiagnostico }}</td>
// <td>{{ record.descLDiagnostico }}</td>
// <td>{{ record.descAreavalidacion }}</td>
// <td>{{ record.codDestino }}</td>
// <td>{{ record.descDestino }}</td>
// <td>{{ record.codCentro }}</td>
// <td>{{ record.descLCentro || record.descCentro }}</td>
// <td *ngFor="let item of camposSensibilidad">
//   {{ record[item] }}
// </td>

export type Field = {
  id: string;
  attribute: string;
  description: string;
  dateFilter?: string;
};

// <td>{{ record.codDestino }}</td>
// <td>{{ record.descDestino }}</td>
export const allFields: Field[] = [
  {
    id: 'I.NUM_PETICION',
    attribute: 'numPeticion',
    description: 'QUERY.I_NUM_PETICION',
  },
  {
    id: 'PA.SKU_PACIENTE',
    attribute: 'skuPaciente',
    description: 'QUERY.PA_SKU_PACIENTE',
  },
  {
    id: 'PA.NOM_PACIENTE',
    attribute: 'nomPaciente',
    description: 'QUERY.PA_NOM_PACIENTE',
  },
  {
    id: 'PA.APELLIDOS',
    attribute: 'apellidos',
    description: 'QUERY.PA_APELLIDOS',
  },
  {
    id: 'PA.FECHA_NAC',
    attribute: 'fechaNac',
    description: 'QUERY.PA_FECHA_NAC',
    dateFilter: 'dd-MM-yy',
  },
  {
    id: 'EDAD',
    attribute: 'edad',
    description: 'QUERY.PA_EDAD',
  },
  {
    id: 'I.FECHA_PETICION_DT',
    attribute: 'fechaPeticionDt',
    description: 'QUERY.I_FECHA_PETICION_DT',
    dateFilter: 'dd-MM-yy HH:mm',
  },
  {
    id: 'DES.COD_DESTINO',
    attribute: 'codDestino',
    description: 'QUERY.DES_COD_DESTINO',
  },
  {
    id: 'DES.DESC_DESTINO',
    attribute: 'descDestino',
    description: 'QUERY.DES_DESC_DESTINO',
  },
  {
    id: 'I.FECHA_EMISION_DT',
    attribute: 'fechaEmisionDt',
    description: 'QUERY.I_FECHA_EMISION_DT',
    dateFilter: 'dd-MM-yy HH:mm',
  },
  {
    id: 'I.FECHA_CITA',
    attribute: 'fechaCita',
    description: 'QUERY.I_FECHA_CITA',
    dateFilter: 'dd-MM-yy HH:mm',
  },
  {
    id: 'I.FECHA_EXTRACCION',
    attribute: 'fechaExtraccion',
    description: 'QUERY.I_FECHA_EXTRACCION',
    dateFilter: 'dd-MM-yy HH:mm',
  },
  {
    id: 'I.FECHA_REGISTRO',
    attribute: 'fechaRegistro',
    description: 'QUERY.I_FECHA_REGISTRO',
    dateFilter: 'dd-MM-yy HH:mm',
  },
  {
    id: 'I.FECHA_RECEPCION',
    attribute: 'fechaRecepcion',
    description: 'QUERY.I_FECHA_RECEPCION',
    dateFilter: 'dd-MM-yy HH:mm',
  },
  {
    id: 'I.MOTIVO_SOLICITUD',
    attribute: 'motivoSolicitud',
    description: 'QUERY.I_MOTIVO_SOLICITUD',
  },
  {
    id: 'I.DESC_L_TIPO_PETICION',
    attribute: 'descLTipoPeticion',
    description: 'QUERY.I_DESC_L_TIPO_PETICION',
  },
  { id: 'I.URGENTE', attribute: 'urgente', description: 'QUERY.I_URGENTE' },
  { id: 'I.INFO_1', attribute: 'info_1', description: 'QUERY.I_INFO_1' },
  { id: 'I.INFO_2', attribute: 'info_2', description: 'QUERY.I_INFO_2' },
  { id: 'I.INFO_3', attribute: 'info_3', description: 'QUERY.I_INFO_3' },
  { id: 'I.INFO_4', attribute: 'info_4', description: 'QUERY.I_INFO_4' },
  {
    id: 'I.INFO4_DT',
    attribute: 'info4Dt',
    description: 'QUERY.I_INFO4_DT',
    dateFilter: 'dd-MM-yy HH:mm',
  },

  { id: 'I.INFO_5', attribute: 'info_5', description: 'QUERY.I_INFO_5' },
  { id: 'I.INFO_6', attribute: 'info_6', description: 'QUERY.I_INFO_6' },
  { id: 'I.INFO_7', attribute: 'info_7', description: 'QUERY.I_INFO_7' },
  { id: 'I.INFO_8', attribute: 'info_8', description: 'QUERY.I_INFO_8' },
  { id: 'I.INFO_9', attribute: 'info_9', description: 'QUERY.I_INFO_9' },
  { id: 'I.INFO_10', attribute: 'info_10', description: 'QUERY.I_INFO_10' },
  { id: 'I.ATTRIB1', attribute: 'attrib1', description: 'QUERY.I_ATTRIB1' },
  { id: 'I.ATTRIB2', attribute: 'attrib2', description: 'QUERY.I_ATTRIB2' },
  { id: 'I.ATTRIB3', attribute: 'attrib3', description: 'QUERY.I_ATTRIB3' },
  { id: 'I.ATTRIB4', attribute: 'attrib4', description: 'QUERY.I_ATTRIB4' },
  { id: 'I.ATTRIB5', attribute: 'attrib5', description: 'QUERY.I_ATTRIB5' },
  {
    id: 'I.MIKROATTRIB2',
    attribute: 'mikroattrib2',
    description: 'QUERY.I_MIKROATTRIB2',
  },
  {
    id: 'I.MIKROATTRIB3',
    attribute: 'mikroattrib3',
    description: 'QUERY.I_MIKROATTRIB3',
  },
  {
    id: 'I.MIKROATTRIB4',
    attribute: 'mikroattrib4',
    description: 'QUERY.I_MIKROATTRIB4',
  },
  {
    id: 'I.MIKROATTRIB5',
    attribute: 'mikroattrib5',
    description: 'QUERY.I_MIKROATTRIB5',
  },
  {
    id: 'I.ADICIONAL1INFORMES',
    attribute: 'adicional1informes',
    description: 'QUERY.I_ADICIONAL1INFORMES',
  },
  {
    id: 'I.ADICIONAL2INFORMES',
    attribute: 'adicional2informes',
    description: 'QUERY.I_ADICIONAL2INFORMES',
  },
  {
    id: 'D.FECHA_METODO_DT',
    attribute: 'fechaMetodoDt',
    description: 'QUERY.D_FECHA_METODO_DT',
    dateFilter: 'dd-MM-yy HH:mm',
  },
  {
    id: 'D.FECHA_RESULTADO',
    attribute: 'fechaResultado',
    description: 'QUERY.D_FECHA_RESULTADO',
    dateFilter: 'dd-MM-yy HH:mm',
  },
  {
    id: 'D.FECHA_VALIDACION_DT',
    attribute: 'fechaValidacionDt',
    description: 'QUERY.D_FECHA_VALIDACION_DT',
    dateFilter: 'dd-MM-yy HH:mm',
  },
  {
    id: 'D.FECHA_IMPRESION',
    attribute: 'fechaImpresion',
    description: 'QUERY.D_FECHA_IMPRESION',
    dateFilter: 'dd-MM-yy HH:mm',
  },

  {
    id: 'D.TIPO_REGISTRO',
    attribute: 'tipoRegistro',
    description: 'QUERY.D_TIPO_REGISTRO',
  },
  {
    id: 'D.FACTURABLE',
    attribute: 'facturable',
    description: 'QUERY.D_FACTURABLE',
  },
  {
    id: 'D.DETERMINACIONES_URGENTE',
    attribute: 'determinacionesUrgente',
    description: 'QUERY.D_DETERMINACIONES_URGENTE',
  },
  {
    id: 'M.DESC_L_METODO',
    attribute: 'descLMetodo',
    description: 'QUERY.M_DESC_L_METODO',
  },
  {
    id: 'D.RESULTADO',
    attribute: 'resultado',
    description: 'QUERY.D_RESULTADO',
  },
  {
    id: 'D.RESCUANTI',
    attribute: 'rescuanti',
    description: 'QUERY.D_RESCUANTI',
  },
  {
    id: 'D.RESULTADO2',
    attribute: 'resultado2',
    description: 'QUERY.D_RESULTADO2',
  },
  {
    id: 'D.RESCUANTI2',
    attribute: 'rescuanti2',
    description: 'QUERY.D_RESCUANTI2',
  },
  {
    id: 'D.PATOLOGIA',
    attribute: 'patologia',
    description: 'QUERY.D_PATOLOGIA',
  },
  {
    id: 'DIAG.COD_DIAGNOSTICO',
    attribute: 'codDiagnostico',
    description: 'QUERY.DIAG_COD_DIAGNOSTICO',
  },
  {
    id: 'DIAG.DESC_DIAGNOSTICO',
    attribute: 'descDiagnostico',
    description: 'QUERY.DIAG_DESC_DIAGNOSTICO',
  },
  {
    id: 'DIAG.DESC_L_DIAGNOSTICO',
    attribute: 'descLDiagnostico',
    description: 'QUERY.DIAG_DESC_L_DIAGNOSTICO',
  },
  {
    id: 'D.DETERMINACIONES_ADICIONAL1',
    attribute: 'determinacionesAdicional1',
    description: 'QUERY.D_DETERMINACIONES_ADICIONAL1',
  },
  {
    id: 'D.VISIBILIDAD',
    attribute: 'visibilidad',
    description: 'QUERY.D_VISIBILIDAD',
  },
  {
    id: 'AN.DESC_L_ANALIZADOR',
    attribute: 'descLAnalizador',
    description: 'QUERY.AN_DESC_L_ANALIZADOR',
  },
  {
    id: 'SKU_ORI_MASTER_METODO',
    attribute: 'skuOriMasterMetodo',
    description: 'QUERY.M_SKU_ORI_MASTER_METODO',
  },
  {
    id: 'A.DESC_L_AREAS',
    attribute: 'descLAreas',
    description: 'QUERY.A_DESC_L_AREAS',
  },

  { id: 'PA.SEXO', attribute: 'sexo', description: 'QUERY.PA_SEXO' },
  {
    id: 'PA.PACIENTE_COD_1',
    attribute: 'pacienteCod_1',
    description: 'QUERY.PA_PACIENTE_COD_1',
  },
  {
    id: 'PA.PACIENTE_COD_2',
    attribute: 'pacienteCod_2',
    description: 'QUERY.PA_PACIENTE_COD_2',
  },
  {
    id: 'PA.PACIENTE_COD_3',
    attribute: 'pacienteCod_3',
    description: 'QUERY.PA_PACIENTE_COD_3',
  },
  {
    id: 'PA.DOMICILIO',
    attribute: 'domicilio',
    description: 'QUERY.PA_DOMICILIO',
  },
  {
    id: 'PA.CODIGO_POSTAL',
    attribute: 'codigoPostal',
    description: 'QUERY.PA_CODIGO_POSTAL',
  },
  { id: 'PA.CIUDAD', attribute: 'ciudad', description: 'QUERY.PA_CIUDAD' },
  { id: 'PA.PAIS', attribute: 'pais', description: 'QUERY.PA_PAIS' },
  {
    id: 'PA.PAIS_ORIGEN',
    attribute: 'paisOrigen',
    description: 'QUERY.PA_PAIS_ORIGEN',
  },
  {
    id: 'CEN.COD_CENTRO',
    attribute: 'codCentro',
    description: 'QUERY.CEN_COD_CENTRO',
  },
  {
    id: 'CEN.DESC_CENTRO',
    attribute: 'descCentro',
    description: 'QUERY.CEN_DESC_CENTRO',
  },
  {
    id: 'CEN.DESC_L_CENTRO',
    attribute: 'descLCentro',
    description: 'QUERY.CEN_DESC_L_CENTRO',
  },
  // {
  //   id: 'PA.TELEFONO',
  //   attribute: 'telefono',
  //   description: 'QUERY.PA_TELEFONO',
  // },
  // { id: 'PA.EMAIL', attribute: 'email', description: 'QUERY.PA_EMAIL' },
  // {
  //   id: 'PA.DOCUMENTO_IDENTIDAD',
  //   attribute: 'documentoIdentidad',
  //   description: 'QUERY.PA_DOCUMENTO_IDENTIDAD',
  // },
  {
    id: 'S.NOMBRE_SERVICIO',
    attribute: 'nombreServicio',
    description: 'QUERY.S_NOMBRE_SERVICIO',
  },
];
